// extracted by mini-css-extract-plugin
export default {"benefitItemMark":"EntityBenefitMark_benefitItemMark__1-bUb"};